<template>
  <section class="locked-section">
    <div class="background-overlay" :style="{ backgroundImage: `url(${bgImage})` }"></div>

    <div class="container content-wrapper text-center px-4" data-aos="fade-up">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">

          <div class="range-badge mb-3 mb-md-4">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>
            PÁGINA EN <span class="d-none d-sm-inline">CONSTRUCCIÓN</span>
          </div>

          <h1 class="main-title fw-900 text-white mb-3 text-uppercase">
            {{ sectionName }}<br>
            <span class="text-danger">PRÓXIMAMENTE</span>
          </h1>

          <p class="lead text-light mb-4 mb-md-5 px-0 px-md-5 description-text">
            Nuestros instructores están finalizando los módulos de entrenamiento y el inventario oficial.
            Estamos trabajando para ofrecerte la mejor experiencia en formación táctica.
          </p>

          <div class="d-flex flex-column flex-md-row justify-content-center gap-3 actions-wrap">
            <RouterLink to="/" class="btn-tactical-solid w-100 w-md-auto">
              <i class="bi bi-house-door-fill me-2"></i> VOLVER AL INICIO
            </RouterLink>

            <button class="btn-tactical-outline w-100 w-md-auto" @click="handleNotify">
              <i class="bi bi-envelope-fill me-2"></i> AVÍSAME
            </button>
          </div>

          <div class="mt-4 mt-md-5 pt-2">
            <p class="coudera-tag">
              Engineered by <a href="https://coudera.com" target="_blank">COUDERA.COM</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import bgImage from "@/assets/img/Tactical/tactical_10.jpg";
import Swal from 'sweetalert2';

defineProps({
  sectionName: {
    type: String,
    default: 'SECCIÓN EN CONSTRUCCIÓN',
  }
});

const handleNotify = () => {
  Swal.fire({
    title: '¡Gracias por tu interés!',
    text: 'Te notificaremos tan pronto como esta sección esté disponible.',
    icon: 'success',
    timer: 3000,
    timerProgressBar: true,
    showConfirmButton: false,
  });
};
</script>

<style scoped>
.locked-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #000;
  padding-top: 130px;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: brightness(0.25) blur(4px);
  z-index: 1;
}

.content-wrapper {
  position: relative;
  z-index: 10;
  padding-bottom: 40px;
}

.fw-900 {
  font-weight: 900;
}

.main-title {
  font-size: calc(1.8rem + 3vw);
  line-height: 1.1;
}

.description-text {
  font-size: 1rem;
}

@media (min-width: 768px) {
  .main-title {
    font-size: 3.8rem;
  }

  .description-text {
    font-size: 1.2rem;
  }
}

@media (min-width: 1200px) {
  .main-title {
    font-size: 5rem;
  }
}

@media (max-width: 1199px) {
    .locked-section {
        padding-top: 80px; 
    }
}

.range-badge {
  display: inline-block;
  background-color: #ff3131;
  color: #fff;
  padding: 6px 15px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 0.75rem;
}

.btn-tactical-solid,
.btn-tactical-outline {
  padding: 14px 25px;
  font-weight: 900;
  text-transform: uppercase;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
}

.btn-tactical-solid {
  background-color: #ff3131;
  color: #fff;
  border: none;
  text-decoration: none;
}

.btn-tactical-solid:hover {
  background-color: #d62828;
  transform: translateY(-2px);
}

.btn-tactical-outline {
  background-color: transparent;
  color: #fff;
  border: 2px solid #fff;
}

.btn-tactical-outline:hover {
  background-color: #fff;
  color: #000;
}

@media (max-width: 767px) {
  .actions-wrap {
    max-width: 280px;
    margin: 0 auto;
  }

  .locked-section {
    padding-top: 100px;
  }
}

.coudera-tag {
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 2px;
}

.coudera-tag a {
  color: #fff;
  text-decoration: none;
  font-weight: 800;
}
</style>